import { Range } from '@/components/reports/types';
import { apiClient } from './client';

export interface SatepsiTest {
    id: string;
    name: string;
    status: string;
    authors: string[];
    publisher: string;
    constructs: string[];
    targetAudience: string;
    ageRange: Range;
    application: string[];
    correction: string[];
    defaultBlocks?: Array<{
        header: {
            id?: string;
            cells: Array<{
                id?: string;
                value: string | number | null;
                rowSpan?: number;
                colSpan?: number;
                mergedInto?: string;
            }>;
        };
        rows: Array<{
            id?: string;
            cells: Array<{
                id?: string;
                value: string | number | null;
                rowSpan?: number;
                colSpan?: number;
                mergedInto?: string;
            }>;
        }>;
        block_type: 'table';
        columnWidths?: number[];
    }>;
    deadlines: {
        approvalDate: string;
        normalizationStudies: string;
        validityStudies: string;
        precisionStudies: string;
    };
}

type Domain = string;

type SatepsiResponse = {
    domains: Array<Domain>;
    tests: Array<SatepsiTest>;
};

export interface SatepsiPagination {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasMore: boolean;
}

export interface SatepsiPaginatedResponse extends SatepsiResponse {
    pagination: SatepsiPagination;
}

interface SatepsiReferencesResponse {
    references: Record<string, string>;
}

interface SatepsiListParams {
    q?: string;
    construct?: string;
    page?: number;
    pageSize?: number;
}

export const satepsiApi = {
    list: async (params: SatepsiListParams = {}): Promise<SatepsiPaginatedResponse> => {
        const { q, construct, page = 1, pageSize = 50 } = params;
        const response = await apiClient.get<SatepsiPaginatedResponse>('/satepsi', {
            params: {
                q: q || undefined,
                construct: construct || undefined,
                page,
                pageSize,
            },
        });
        return response as unknown as SatepsiPaginatedResponse;
    },
    references: async (ids: string[]): Promise<SatepsiReferencesResponse> => {
        if (ids.length === 0) return { references: {} };

        const response = await apiClient.get<SatepsiReferencesResponse>('/satepsi/references', {
            params: {
                ids: ids.join(','),
            },
        });

        return response as unknown as SatepsiReferencesResponse;
    },
};
